import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Input, Label } from '@ipc/ipc-components';
import {
  getData,
  getColumns,
  getIsLoading,
} from '../redux/selectors/BalanceModificationTransactionsSelectors';
import ListTable from '../../../../../common/tables/ListTable';
import TableDefinitions from '../../../../../common/TableDefinitions';
import { getAssetType } from '../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { tableLoadData } from '../../../../../common/tables/actions/ListTableActions';
import { getClickedRowOnTable } from '../../../../../common/tables/reducers/selectors/ListTableSelectors';
import BalanceOnHandTransactionsHistoryContainer from '../../transactions-history/balance-on-hand/containers/BalanceOnHandTransactionsHistoryContainer';
import BalanceModificationTransactionsCreate from '../create/containers/BalanceModificationTransactionsCreate';
import downloadTypes from '../../../../../common/tables/excel/DownloadTypes';
import { TransactionsStyle } from '../../component/Transactions.styles';
import { getUserRole } from '../../../../../common/user/redux/selectors/UserDataSelectors';

class BalanceModificationTransactionsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDayCount: 10,
      showCreateModal: false,
    };
    this.clickApplyButton = this.clickApplyButton.bind(this);
    this.createTransaction = this.createTransaction.bind(this);
    this.clickApplyButton();
  }

  componentDidUpdate(prevProps) {
    if (this.props.clickedRow !== prevProps.clickedRow) {
      this.clickApplyButton();
    }
  }

  showCreateFormModal = () => {
    this.setState({
      showCreateModal: true,
    });
  }

  hideCreateFormModal = () => {
    this.setState({
      showCreateModal: false,
    });
  }

  enterPressed = (e) => {
    const code = e.keyCode || e.which;
    if (code === 13) {
      this.clickApplyButton();
    }
  }

  handleChange(e) {
    this.setState({
      selectedDayCount: e.target.value,
    });
  }

  clickApplyButton() {
    this.props.tableLoadData(
      { tableId: TableDefinitions.BALANCE_MODIFICATION_TRANSACTIONS.id },
      this.props.appContext.appContext,
      { impcCode: this.props.clickedRow.impc, numberOfDays: this.state.selectedDayCount },
    );
  }

  createTransaction() {
    this.setState({
      showCreateModal: true,
    });
  }

  render() {
    const {
      showCreateModal,
    } = this.state;
    return (
      <TransactionsStyle>
        <Label>
          Show transactions for the last
          <Input
            className="last-day-input"
            value={this.state.selectedDayCount}
            onChange={(e) => this.handleChange(e)}
            onKeyPress={this.enterPressed}
          />
          days
        </Label>
        <Button className="action-buttons" onClick={this.clickApplyButton}>
          Apply
        </Button>
        {(this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
          || this.props.userRole.includes('IPC_TRAY_MANAGER')
          || this.props.userRole.includes('IPC_BAG_MANAGER')) && (
          <Button className="action-buttons" onClick={this.createTransaction}>
            Create Balance Modification
          </Button>
        )}
        <ListTable
          listId={TableDefinitions.BALANCE_MODIFICATION_TRANSACTIONS.id}
          loading={this.props.isLoading}
          columns={this.props.columns}
          data={this.props.data}
          keyField="id"
          selectCheckbox
          downloadType={downloadTypes.EXCEL}
          getSubComponentProps={(row) => (
            <div style={{ padding: '20px' }}>
              <BalanceOnHandTransactionsHistoryContainer
                row={row}
                refreshTransactions={this.clickApplyButton}
              />
            </div>
          )}
        />
        {showCreateModal && (
          <BalanceModificationTransactionsCreate
            closeDialog={this.hideCreateFormModal}
            openDialog={this.showCreateFormModal}
            row={this.props.clickedRow}
            refreshTransactions={this.clickApplyButton}
          />
        )}
      </TransactionsStyle>
    );
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    appContext: getAssetType(state),
    clickedRow: getClickedRowOnTable(state),
    isLoading: getIsLoading(state),
    userRole: getUserRole(state),
  };
}

BalanceModificationTransactionsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  appContext: PropTypes.objectOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  clickedRow: PropTypes.objectOf(PropTypes.shape),
  isLoading: PropTypes.bool,
  userRole: PropTypes.arrayOf(PropTypes.string),
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BalanceModificationTransactionsContainer);
